// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum GroundTruthJobStatus {
	Uploaded = 0,
	Stitching = 1,
	Counting = 2,
	Complete = 3,
	Failed = 4,
}

export const GroundTruthJobStatusDisplayNames: { [key in keyof typeof GroundTruthJobStatus]?: string} = {
	"Uploaded": "Uploaded",
	0 : "Uploaded",
	"Stitching": "Stitching",
	1 : "Stitching",
	"Counting": "Counting",
	2 : "Counting",
	"Complete": "Complete",
	3 : "Complete",
	"Failed": "Failed",
	4 : "Failed",
}

export const getGroundTruthJobStatusDisplayName = (key: GroundTruthJobStatus | (keyof typeof GroundTruthJobStatus & string)) => {
	return GroundTruthJobStatusDisplayNames[key];
}

